// components/ShippingMethods/ShippingMethods.jsx
import React, { useState, useCallback, useMemo } from 'react';
import { Form, Spinner, Alert } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import NumberFormat from 'react-number-format';
import { order_shipping_setter } from '../../actions/cartActions';
import { errorAction } from '../../actions/request_error';
import { peyk_id, post_id } from '../../confg';

const ShippingMethods = ({
  shippingMethods = [],
  shippingInsurance = {},
  shippingPrice = null,
  selectedShipping = null,
  onShippingSelect = () => {},
  loading = false,
  showError = false, // پراپ جدید برای نمایش ارور
  // errorMessage = 'روش ارسال را انتخاب کنید', // پیام ارور قابل تنظیم
}) => {
  const dispatch = useDispatch();
  const translate = useSelector((state) => getTranslate(state.localize));
  const orderAddress = useSelector((state) => state.cart.order_address);
  const orderCity = useSelector((state) => state.cart.order_city);

  const handleShippingSelect = useCallback(
    (methodId) => {
      if (!orderAddress) {
        dispatch(errorAction(translate('address_empty')));
        return;
      }

      dispatch(order_shipping_setter(methodId));
      onShippingSelect(methodId);
    },
    [orderAddress, dispatch, translate, onShippingSelect],
  );

  const getShippingPriceText = useCallback(
    (shippingId) => {
      if (loading) {
        return <Spinner animation='border' size='sm' />;
      }

      switch (shippingId) {
        case 1:
          return 'زمان ارسال برای تهران تا دو روز کاری می‌باشد. همکاران ما قبل از ارسال با شما تماس خواهند گرفت. هزینه پیک با توجه به آدرس شما محاسبه خواهد شد.';

        case 2:
          return (
            <>
              ارسال با بیمه (
              <NumberFormat value={shippingInsurance.with_insurance} displayType={'text'} thousandSeparator={true} /> تومان)
<p style={{marginTop:'10px'}}>ارسال به شهرستان دو تا سه روز کاری زمان می‌برد</p>
            </>
          );

        case 3:
          return 'رایگان';

        default:
          return shippingPrice ? <NumberFormat value={shippingPrice} displayType={'text'} suffix=' تومان' thousandSeparator={true} /> : 'محاسبه هزینه...';
      }
    },
    [loading, shippingInsurance.with_insurance, shippingPrice],
  );

  const filteredMethods = useMemo(() => {
    return shippingMethods.filter((method) => {
      if (orderCity === 'تهران') {
        return method.id !== post_id;
      } else {
        return method.id !== peyk_id;
      }
    });
  }, [shippingMethods, orderCity]);

  if (!shippingMethods.length) {
    return (
      <div className='shipping-loading'>
        <Spinner animation='border' />
      </div>
    );
  }

  return (
    <div className={`shipping-methods-container ${showError ? 'has-error' : ''}`}>
      <div className='section-title address-label'>{translate('choose-choose-deliver-time')}</div>

      <div className='shipping-methods-list'>
        {filteredMethods.map((method) => (
          <ShippingMethodCard
            key={method.id}
            method={method}
            isSelected={method.id === selectedShipping}
            onSelect={handleShippingSelect}
            orderAddress={orderAddress}
            translate={translate}
            getShippingPriceText={getShippingPriceText}
            hasError={showError}
          />
        ))}
      </div>

      <style jsx>{`
        .shipping-methods-container {
          margin-bottom: 15px;
          background-color: white;
          border: 2px solid #01494b;
          padding: 20px;
          border-radius: 8px;
          margin-top: 0px;
          transition: all 0.3s ease;
        }

        /* فقط بردر قرمز در زمان ارور */
        .shipping-methods-container.has-error {
          border-color: #dc3545;
        }

        .section-title {
          margin-top: 16px;
          color: #333;
          font-size: 0.85rem;
          color: #01494b;
          font-weight: 600;
          margin-bottom: 0.5rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .shipping-error-alert {
          margin-bottom: 15px;
          border: none;
          border-radius: 8px;
          background-color: #f8d7da;
          border-left: 4px solid #dc3545;
          animation: slideDown 0.3s ease-out;
        }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .error-content {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 13px;
          color: #721c24;
          font-weight: 500;
        }

        .error-content i {
          color: #dc3545;
          font-size: 14px;
        }

        .shipping-loading {
          text-align: center;
          padding: 40px 20px;
        }

        .shipping-methods-list {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        @media (max-width: 768px) {
          .shipping-methods-container {
            font-size: 12px !important;
          }

          .error-content {
            font-size: 12px;
          }
        }
      `}</style>
    </div>
  );
};

// کامپوننت کارت روش ارسال - ساده شده
const ShippingMethodCard = React.memo(({ method, isSelected, onSelect, orderAddress, translate, getShippingPriceText, hasError = false }) => {
  const [isAnimating, setIsAnimating] = useState(false);

  const handleClick = useCallback(
    (e) => {
      e.preventDefault();
      if (!orderAddress) return;

      setIsAnimating(true);
      onSelect(method.id);

      // Reset animation state
      setTimeout(() => setIsAnimating(false), 300);
    },
    [onSelect, method.id, orderAddress],
  );

  return (
    <div className={`shipping-card ${isSelected ? 'selected' : ''} ${isAnimating ? 'animating' : ''}`}>
      <div className='card-header' onClick={handleClick}>
        <div className='method-selector'>
          <Form.Check
            className='custom-switch'
            type='switch'
            checked={isSelected}
            id={`shipping-switch-${method.id}`}
            disabled={!orderAddress}
            onChange={handleClick}
            label={translate(method.name)}
          />
        </div>
      </div>

      <div className={`shipping-details ${isSelected && orderAddress ? 'expanded' : 'collapsed'}`}>
        <div className='details-content'>
          <div className='price-section'>
            <span className='price-label'>هزینه ارسال:</span>
            <div className='price-value'>{getShippingPriceText(method.id)}</div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .shipping-card {
          border: 2px solid #e0e0e0;
          border-radius: 8px;
          overflow: hidden;
          transition: all 0.2s ease-in-out;
          background: white;
          position: relative;
        }

        .shipping-card:hover {
          border-color: #01494b;
          box-shadow: 0 2px 8px rgba(1, 73, 75, 0.1);
        }

        .shipping-card.selected {
          border-color: #01494b;
          box-shadow: 0 4px 12px rgba(1, 73, 75, 0.15);
        }

        .shipping-card.animating {
          transform: scale(1.02);
        }

        .card-header {
          padding: 16px 20px;
          cursor: pointer;
          background: #f8f9fa;
          transition: background-color 0.2s ease;
          user-select: none;
          position: relative;
        }

        .card-header:hover {
          background: #e9ecef;
        }

        .shipping-card.selected .card-header {
          background: rgba(1, 73, 75, 0.05);
        }

        .method-selector {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .custom-switch {
          font-size: 16px;
          font-weight: 600;
          color: #333;
        }

        .shipping-details {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .shipping-details.expanded {
          max-height: 200px;
        }

        .details-content {
          padding: 16px 20px;
          background: white;
          border-top: 1px solid #f0f0f0;
        }

        .price-section {
          display: flex;
          align-items: flex-start;
          gap: 8px;
          flex-direction: column;
        }

        .price-label {
          font-size: 14px;
          font-weight: 600;
          color: #666;
          margin-bottom: 4px;
        }

        .price-value {
          font-size: 14px;
          color: #333;
          line-height: 1.5;
        }

        /* بهینه‌سازی برای موبایل */
        @media (max-width: 768px) {
          .shipping-card {
            border-radius: 8px;
          }

          .card-header {
            padding: 12px 16px;
          }

          .details-content {
            padding: 12px 16px;
          }

          .custom-switch {
            font-size: 14px;
          }

          .price-label {
            font-size: 12px;
          }

          .price-value {
            font-size: 13px;
          }
        }

        /* بهینه‌سازی برای accessibility */
        .shipping-card:focus-within {
          outline: 2px solid #01494b;
          outline-offset: 2px;
        }

        .card-header:focus {
          outline: none;
        }

        /* انیمیشن برای disabled state */
        .shipping-card:has(.custom-switch:disabled) {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .shipping-card:has(.custom-switch:disabled) .card-header {
          cursor: not-allowed;
          background: #f5f5f5;
        }

        .shipping-card:has(.custom-switch:disabled):hover {
          border-color: #e0e0e0;
          box-shadow: none;
        }
      `}</style>
    </div>
  );
});

ShippingMethodCard.displayName = 'ShippingMethodCard';

export default ShippingMethods;
